import styled from 'styled-components/macro';
import { ResultsBox } from '../../../../../components/tools/SearchPage/Search.styles';
import * as colors from '../../../../../components/common/colorConstants';
import { mediumHeightScreens, smallScreens } from '../../../../../components/common/fontElements';

export const Results = styled(ResultsBox)`
  padding: 30px;
`;

export const ResultsHeader = styled.p`
  color: ${colors.darkGray9};
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  margin: 20px 0 20px 10px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
    margin: 10px 0 10px 10px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
    margin: 10px 0 10px 10px;
  }
`;

export const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
  width: ${(props) => props.width || 'auto'};
`;

export const ResultsHeaderRow = styled.div`
  padding: 8px 0 8px 58px;
  line-height: 1.42857143;
  vertical-align: top;
  color: ${colors.darkGray9};
  display: flex;
`;

export const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 300px;
`;
